export default "/images/cardCompanyGallery-1.png?f4dcd582db74c2887a32eedb2a6f4cf3";